<section class="business-registration-ads-intro">
  <div class="box">
    <div class="box-left">
      <h1 class="box-left__title"
        ><span>{{ 'BUSINESS_REGISTRATION_ADS.INTRO.TITLE' | translate }}</span>
      </h1>
      <div class="box-left__detail"
        ><span>{{ 'BUSINESS_REGISTRATION_ADS.INTRO.DETAIL' | translate }}</span></div
      >
      <div class="box-left__pricing">
        <span class="box-left__pricing--text">{{ 'BUSINESS_REGISTRATION_ADS.INTRO.PRICING.TEXT' | translate }}</span>
        <span class="box-left__pricing--price">9,990.-</span>
        <span class="box-left__pricing--oldpricing"
          >{{ 'BUSINESS_REGISTRATION_ADS.INTRO.PRICING.TEXT_2' | translate }} <del><span>22,990.</span></del
          >-</span
        >
      </div>
      <div class="box-left__btn">
        <a
          class="box-left__btn--layout"
          href="https://form.flowaccount.com/th-th/businessregistrationservice"
          target="_blank"
          ><span>{{ 'BUSINESS_REGISTRATION_ADS.INTRO.BTN' | translate }}</span>
        </a>
      </div>
      <span class="box-left__clarify">{{ 'BUSINESS_REGISTRATION_ADS.INTRO.BTN_TEXT_UNDER' | translate }}</span>
    </div>
    <div class="box-right">
      <picture>
        <source
          srcset="https://flowaccountcdn.com/new_landing/image/functions/business/business_header_v5.webp"
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/business-registration/business_header_into.png"
          loading="eager"
          [alt]="'BUSINESS_REGISTRATION_ADS.INTRO.TITLE' | translate"
          class="box-right__image"
        />
      </picture>
    </div>
  </div>
</section>
